import httpClient from "./httpClient";

const prefix = "/proceedings";

export async function getProceedingByPartner(id) {
  return (await httpClient.get(`${prefix}/get-by-partner/${id}`)).data;
}

export async function getProceedingByPartnerAndType(id, type) {
  return (await httpClient.get(`${prefix}/${id}/${type}`)).data;
}

export async function getTemplateByPosition(id: number) {
  return (await httpClient.get(`${prefix}/find-template/${id}`)).data;
}

export async function getAllAvailablesTemplates() {
  return (await httpClient.get(`${prefix}/find-all-templates-availables`)).data;
}

export async function updateTemplate(id: number, data: any) {
  return (await httpClient.put(`${prefix}/update-template/${id}`, data)).data;
}

export async function deleteFileProceeding(id: number) {
  return (await httpClient.delete(`${prefix}/delete-file-proceeding/${id}`))
    .data;
}

export async function getFileById(id: string) {
  return (await httpClient.get(`${prefix}/find-file/${id}`)).data;
}

export async function getFilePreviewById(id: string) {
  return (await httpClient.get(`${prefix}/find-file-preview/${id}`)).data;
}

export async function getPdfPreviewById(id: string) {
  return (await httpClient.get(`${prefix}/find-pdf-preview/${id}`)).data;
}

export async function getProceedingsSummary(partnerId: number) {
  return (await httpClient.get(`${prefix}/summary/${partnerId}`)).data;
}

export async function getHasMotoPartner(id: number) {
  return (await httpClient.get(`/partners/has-moto/${id}`)).data;
}

export async function deleteFileMotorcycle(partnerId: number, fileId: string) {
  return (
    await httpClient.delete(`/partners/delete-file-moto/${partnerId}/${fileId}`)
  ).data;
}

export async function getPendingDocumentsForReview(params?: {
  limit?: number;
  offset?: number;
  requestType?: 'upload' | 'deletion';
  search?: string;
  sort?: string;
  order?: 'ASC' | 'DESC';
}) {
  const query = new URLSearchParams();
  if (params?.limit) query.append("limit", String(params.limit));
  if (params?.offset) query.append("offset", String(params.offset));
  if (params?.requestType) query.append("requestType", params.requestType);
  if (params?.search) query.append("search", params.search);
  if (params?.sort) query.append("sort", params.sort);
  if (params?.order) query.append("order", params.order);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return (await httpClient.get(`/document-review/pending${suffix}`)).data;
}

export async function reviewPendingDocument(
  id: number,
  payload: { status: "approved" | "rejected"; comment?: string }
) {
  return (await httpClient.patch(`/document-review/${id}/process`, payload)).data;
}

export async function syncDocumentsForReview() {
  return (await httpClient.post(`/document-review/sync`)).data;
}

export async function getDocumentReviewStats(params?: {
  requestType?: "upload" | "deletion";
}) {
  const query = new URLSearchParams();
  if (params?.requestType) query.append("requestType", params.requestType);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return (await httpClient.get(`/document-review/stats${suffix}`)).data;
}

export async function getProceedingByCandidate(candidateId: number) {
  return (await httpClient.get(`${prefix}/get-by-candidate/${candidateId}`)).data;
}

export async function createProceedingForCandidate(candidateId: number, templateId: number) {
  return (await httpClient.post(`${prefix}/create-for-candidate`, {
    candidateId,
    templateId,
  })).data;
}

export async function getProceedingByCandidateAndType(candidateId: number, typeId: number) {
  return (await httpClient.get(`${prefix}/get-by-candidate-and-type/${candidateId}/${typeId}`)).data;
}
